import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Divider, Grid, Icon, IconButton, Modal, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { ToastContent } from "../../../../shared/components";
import { LoadingComp } from "../../../../shared/components/loading/Loading";
import { useToast } from "../../../../shared/hooks";
import { ProvisionService } from "../../../../shared/services/api/provisoes/ProvisionService";

interface Props {
	open: boolean;
	borderoId: string;
	onClose: () => void;
	onSuccess: () => void;
}

// Suspender (item 6/14, GARV2-1463/1464) — chamado do lado do Financeiro, grava
// suspendedBy: "financeiro". Enquanto suspenso assim, o setor de Sinistro não consegue reverter
// (só visualizar o motivo) — regra de prevalência já implementada no BorderoRowMenu do Sinistro.
export const ModalSuspendBorderoFinanceiro = ({ open, borderoId, onClose, onSuccess }: Props) => {
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down("sm"));
	const toastHandler = useToast();
	const [reason, setReason] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	const handleConfirm = async () => {
		setIsLoading(true);
		const result = await ProvisionService.borderoSuspend(borderoId, { origin: "financeiro", reason: reason || undefined });
		setIsLoading(false);

		if (result instanceof Error) {
			toastHandler.present({ type: "error", position: "top-right", messageOrContent: <ToastContent title="Erro" content={result.message} /> });
			return;
		}

		toastHandler.present({
			type: "success",
			position: "top-right",
			messageOrContent: <ToastContent title="Sucesso" content="Borderô suspenso." />,
		});
		setReason("");
		onSuccess();
		onClose();
	};

	return (
		<Modal open={open} onClose={onClose}>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					bgcolor: "background.paper",
					boxShadow: 24,
					p: 4,
					width: "95%",
					maxWidth: 560,
					borderRadius: 3,
				}}
			>
				<LoadingComp isopen={isLoading} />

				<Grid container justifyContent="space-between" alignItems="center">
					<Typography variant="h5" sx={{ color: "primary.main", fontWeight: 300 }}>
						Suspender Borderô
					</Typography>
					<IconButton onClick={onClose} size="small">
						<CloseIcon />
					</IconButton>
				</Grid>

				<Divider sx={{ my: 2 }} />

				<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
					Fica travado pro setor de Sinistro reverter — só o Financeiro consegue retirar essa suspensão.
				</Typography>

				<TextField fullWidth label="Motivo (opcional)" multiline minRows={3} value={reason} onChange={(e) => setReason(e.target.value)} />

				<Grid container justifyContent="flex-end" flexDirection={smDown ? "column" : "row"} gap={2} mt={3}>
					<Button color="inherit" variant="contained" startIcon={<Icon>arrow_back</Icon>} onClick={onClose} sx={{ minWidth: 140 }}>
						Voltar
					</Button>
					<Button color="warning" variant="contained" startIcon={<Icon>pause_circle</Icon>} onClick={handleConfirm} sx={{ minWidth: 140 }}>
						Suspender
					</Button>
				</Grid>
			</Box>
		</Modal>
	);
};
